import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';

import {
    EMPTY,
    Observable,
    throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationFacade } from '@cash/shared/authentication';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class AccessDeniedInterceptor implements HttpInterceptor {
    constructor(
        private readonly authenticationFacade: AuthenticationFacade,
        private readonly router: Router,
    ) {
    }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((response) => {
                if (
                    response instanceof HttpErrorResponse
                    && response.status === 401
                ) {
                    const loginUrl = `${environment.api.nilo.user.root}/users/actions/login`;

                    if (response.url === loginUrl) {
                        this.authenticationFacade.logOut();
                        this.router.navigate(['/']).then();
                    } else {
                        this.router.navigate(['/401']).then();
                    }

                    return EMPTY;
                }

                return throwError(() => response);
            }),
        );
    }
}
